export default __webpack_public_path__ + "static/media/PAULAS CHOICE INTERVIEW_FINWEB7.aba72000.png";